export const getNewReqClientEndpoint = () =>
  (`/api/user-profile/unActiveRequestedUser`);
export const getActiveClientEndpoint = () =>
  (`/api/user-profile/activeRequestedUser`);